var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperI(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 76,
    viewBox: "0 0 3 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.19999 0.824005H0.399994V6.22401H2.19999V0.824005Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19999 60.368H0.399994V51.8H2.19999V60.368ZM2.19999 42.368H0.399994V33.8H2.19999V42.368ZM2.19999 24.368H0.399994V15.8H2.19999V24.368Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19999 69.848H0.399994V75.248H2.19999V69.848Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperI);
export default __webpack_public_path__ + "static/media/UPPER_I.2220a1ba11568a206f0a27cee2f4092d.svg";
export { ForwardRef as ReactComponent };